import axiosPublicClient from "../../../../../../axiosPublicClient"

export default async (data) => {
    const result = await axiosPublicClient.post(`/confirm-paper-process`, data)

    return result.data
}
